module.exports = __webpack_public_path__ + "static/def3_vert-137d588aa39d14fae82971c58bc50c7e.jpg";